/**
 * Validates a post-login `return` URL taken from the query string.
 *
 * Only same-origin, absolute in-app paths are allowed. Protocol-relative
 * (`//host`) and backslash (`/\host`) forms are rejected: although the value
 * is currently consumed via react-router's <Navigate> (which routes in-app
 * and cannot leave the origin), validating here keeps the login and MFA paths
 * consistent and prevents an open redirect should the value ever be handed to
 * `window.location` instead.
 *
 * Returns the safe path, or null when the value is missing or unsafe — callers
 * should fall back to the default landing page ('/') in that case.
 */
export function getSafeReturnPath(
  raw: string | string[] | null | undefined
): string | null {
  const value = Array.isArray(raw) ? raw[0] : raw;
  if (typeof value !== 'string' || value.length === 0) return null;
  // Must be an absolute in-app path...
  if (!value.startsWith('/')) return null;
  // ...but not protocol-relative (//evil.com) or backslash-tricked (/\evil.com).
  if (value.startsWith('//') || value.startsWith('/\\')) return null;
  return value;
}
